module.exports = __webpack_public_path__ + "img/access_denied.c6e07864.png";